import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './auth';
import Router from './routes';
import NewRouter from './newLayout/routes/index';
import { BaSeRoot } from '@base/react';
import { AppProvider, useApp } from './context/app';
import { FiltersProvider } from './context/filters';
import { Global } from '@emotion/react';
import { globalStyles } from './newLayout/styles/global';
import { QueryClient, QueryClientProvider } from 'react-query';

import './style.scss';

const RenderRouter = () => {
  const { newLayout } = useApp();
  return newLayout ? <NewRouter /> : <Router />;
};

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BaSeRoot>
        <AuthProvider>
          <AppProvider>
            <FiltersProvider>
              <RenderRouter />
              <Global styles={globalStyles} />
            </FiltersProvider>
          </AppProvider>
        </AuthProvider>
      </BaSeRoot>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register();
